<script lang="ts" setup>
import type { Projects_Plain } from '@webamboos/admin/src/components/sections/interfaces/Projects'

const props = defineProps<{
  data: Projects_Plain
}>()
</script>

<template>
  <Container class="screen-content flex flex-col items-center space-y-6 pb-16 pt-32 text-center lg:pt-24">
    <Heading as="h3" size="caption">{{ props.data.headline }}</Heading>
    <Heading as="h2" size="large" class="w-full lg:w-1/2">{{ props.data.title }}</Heading>

    <Paragraph class="w-full lg:w-1/2">{{ props.data.body }}</Paragraph>

    <Action :size="props.data.action?.size" :intent="props.data.action?.intent">
      <NuxtLink :href="props.data.action?.href">{{ props.data.action?.label }}</NuxtLink>
    </Action>
  </Container>
  <ProjectsSlider class="pb-32" :projects="props.data.projects || []" />
</template>
